import jwtDecode from 'jwt-decode';

// Actions
const LOGIN_START = 'chama/auth/LOGIN_START';
const LOGIN_SUCCESS = 'chama/auth/LOGIN_SUCCESS';
const LOGOUT = 'chama/auth/LOGOUT';
const AUTH_ERROR = 'chama/auth/AUTH_ERROR';
const APPLY_ROLE = 'chama/auth/APPLY_ROLE';
const APPLY_USER_DISPLAY_NAME = 'chama/auth/APPLY_USER_DISPLAY_NAME';
const APPLY_PERMISSIONS = 'chama/auth/APPLY_PERMISSIONS';

const initialState = {
  loading: false,
  success: false,
  error: null,
  chamaID: null,
  role: null,
  permissions: null,
  userDisplayName: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        uid: action.payload.uid,
        chamaID: action.payload.chamaID,
        role: action.payload.role,
        permissions: action.payload.permissions,
        userDisplayName: action.payload.displayName,
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    case AUTH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case APPLY_ROLE:
      return {
        ...state,
        role: action.payload,
      };
    case APPLY_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    case APPLY_USER_DISPLAY_NAME:
      return {
        ...state,
        userDisplayName: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
function startLogin() {
  return { type: LOGIN_START };
}
function onLoginSuccess(payload) {
  return { type: LOGIN_SUCCESS, payload };
}
function onLoginFailure(payload) {
  return { type: AUTH_ERROR, payload };
}
function onLogout() {
  return { type: LOGOUT };
}

// Actions
export const login = () => async (dispatch, getState, { api, firebaseClient }) => {
  dispatch(startLogin());
  try {
    // Google sign in
    const {
      user: { ra },
    } = await firebaseClient.signInWithGoogle();
    // use regular Google token to ask for enriched one
    api.signInWithToken(() => ra);
    await api.enrichToken();
    // reissue token and fire updateToken();
    return await firebaseClient.getToken(true);
  } catch (e) {
    console.log(e);
    return dispatch(onLoginFailure(e));
  }
};

export const updateToken = user => async (dispatch, getState, { api, firebaseClient }) => {
  try {
    const {
      auth: { success },
    } = getState();
    if (success) return false;

    api.signInWithToken(() => firebaseClient.getToken());

    const { uid, ra, displayName } = user;
    // get user roles from token
    const { cb_roles: cbRoles, c_id: chamaID } = jwtDecode(ra);
    // throw error if user has no roles
    if (!cbRoles.length) return dispatch(onLoginFailure({ code: 'unauthorised' }));
    // ask BE for permissions
    const permissions = await api.getPermissions();

    return dispatch(
      onLoginSuccess({
        role: cbRoles,
        uid,
        chamaID,
        permissions: processPermissions(cbRoles, permissions),
        displayName,
      }),
    );
  } catch (e) {
    console.log(e);
    return dispatch(onLoginFailure(e));
  }
};

export const logout = () => async (dispatch, getState, { firebaseClient }) => {
  dispatch(onLogout());
  firebaseClient.signOut();
};

// Helpers
function processPermissions(role, permissions) {
  const roles = role.split('|');

  return Object.keys(permissions).reduce((result, key) => {
    if (roles.includes(key)) {
      return [...result, ...permissions[key]];
    }
    return result;
  }, []);
}



// WEBPACK FOOTER //
// ./src/modules/auth/redux.jsx